"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = __importDefault(require("./debt_actions/index"));
var index_2 = __importDefault(require("./debt_supporting_documents/index"));
var index_3 = __importDefault(require("./demands/index"));
/**
 *
 *
 * @param {Recover} recover A reference to the Recover class
 * @param {number} debtID A reference to a single debt
 * @class Debts
 * @classdesc Handles debts in Recover.
 */
var Debts = /** @class */ (function () {
    function Debts(recover, debtID) {
        var _this = this;
        this.recover = recover;
        this.debtID = debtID;
        /**
         *
         *
         * @memberof Debts
         * @returns {Debts} Returns the current intsance of this class.
         * @property {number} debtId A reference to a single debt
         * @description Sets a debtID for use by child classes
         */
        this.access = function (debtId) {
            _this.debtID = debtId;
            return _this;
        };
        /**
         *
         *
         * @memberof Debts
         * @returns {SuccessfulIndexDebts} Returns a message and an array of all debts
         * @description Returns an index of all debts
         */
        this.index = function () {
            return _this.recover.request('/debts', 'GET', null, null);
        };
        /**
         *
         *
         * @memberof Debts
         * @returns {SuccessfulGetDebts} Returns a message and a single debt
         * @property {number} id A reference to a single debt
         * @description Returns a single debt
         */
        this.get = function (id) {
            return _this.recover.request("/debts/" + id, 'GET', null, null);
        };
        /**
         *
         *
         * @memberof Debts
         * @returns {SuccessfulGetDebts} Returns a message and a single debt
         * @property {string} ref A reference to a single debt
         * @description Returns a debt based on the reference provided.
         */
        this.getByRef = function (ref) {
            return _this.recover.request("/debts/ref/" + ref, 'GET', null, null);
        };
        /**
         *
         *
         * @memberof Debts
         * @returns {SuccessfulCreateDebts} Returns a message and the newly created debt
         * @property {INewDebtRequest} newDebt A JSON containing; interest_rate(number), invoice_due_date(string), invoice_reference(string), invoice_sent_date(string), original_amount(number), purchase_order_date(string), purchase_order_number(sting), reminder_sent_date(string), source_type(string), & nested debtor object containing; address_1(string), address_2(string), city(string)(string), country(string), email(string), name(string), post_code(string), protocol_id(number)
         * @description Creates a new debt
         */
        this.create = function (newDebt) {
            return _this.recover.request('/debts', 'POST', newDebt, null);
        };
        /**
         *
         *
         * @memberof Debts
         * @returns {SuccessfulEditDebts} Returns a message and the updated debt
         * @property {number} id A reference to a single debt
         * @property {INewDebtRequest} updatedDebt A JSON made up of any of the fields used in a new debt
         * @description Edits a debt
         */
        this.edit = function (id, updatedDebt) {
            return _this.recover.request("/debts/" + id, 'PUT', updatedDebt, null);
        };
        /**
         *
         *
         * @memberof Debts
         * @returns {DebtSuportingDocuments} Returns a new instance of DebtSupportingDocuments
         * @property {Recover} recover A reference to the Recover class
         * @property {number} debtID A reference to a single debt
         * @description Returns a new instance of the DebtSupportingDocuments class
         */
        this.supporting_documents = function () {
            return new index_2.default(_this.recover, _this.debtID);
        };
        /**
         *
         *
         * @memberof Debts
         * @returns {DebtActions} Returns a new instance of DebtActions
         * @property {Recover} recover A reference to the Recover class
         * @property {number} debtID A reference to a single debt
         * @description Returns a new instance of the DebtActions class
         */
        this.actions = function () { return new index_1.default(_this.recover, _this.debtID); };
        /**
         *
         *
         * @memberof Debts
         * @returns {DebtDemands} Returns a new instance of DebtDemands
         * @property {Recover} recover A reference to the Recover class
         * @property {number} debtID A reference to a single debt
         * @description Returns a new instance of the DebtDemands class
         */
        this.demands = function () { return new index_3.default(_this.recover, _this.debtID); };
    }
    return Debts;
}());
exports.default = Debts;
